// TODO : publish thank you for feedback message

import React from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FaPaperPlane } from "react-icons/fa";
import { useNavigate } from "react-router";

import * as api from "../../api/api";
import Layout, { Title } from "../../components/Layout/Layout";
import { useAuth } from "../../contexts/auth_provider";
import urls from "../../urls.jsx";

export default function FeedbackPage() {
    const navigate = useNavigate();
    const feedbackDescriptionRef = React.useRef(undefined);
    const { user } = useAuth();

    function onSendFeedback() {
        const feedback = feedbackDescriptionRef.current.value;
        api.sendFeedback(user.uid, feedback);
        navigate(urls.home());
    }

    React.useEffect(() => {
        // focus the textarea after the page renders
        feedbackDescriptionRef.current?.focus();
    }, []);

    return (
        <Layout>
            <title>Feedback | MyCorvus</title>
            <Card>
                <Title title="Feedback" />
                <Card.Body className="px-4 pt-0">
                    <Card.Text>
                        <Row>
                            <Col xs={12}>
                                <Form.Group className="m-0 p-0 mb-4">
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder="What could be improved?"
                                        ref={feedbackDescriptionRef}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <Button
                                    className="me-2"
                                    variant="success"
                                    onClick={() => {
                                        onSendFeedback();
                                    }}
                                >
                                    <FaPaperPlane className="me-2" />
                                    Send feedback
                                </Button>
                            </Col>
                        </Row>
                    </Card.Text>
                </Card.Body>
            </Card>
        </Layout>
    );
}
